import { Image } from "common/types/images";

import { getCdnImageDetails } from "seneca-common/utils/images";

import {
  ImageAssetParameters,
  TextBlockContent,
  TextBlockContentSource
} from "../types";

export function getModuleAssets(source: TextBlockContent): Array<Image> {
  return [source.imageUrl as Image];
}

export function transformModuleAssets(
  source: TextBlockContentSource,
  assetParams: ImageAssetParameters
): TextBlockContent {
  return {
    ...source,
    imageUrl: getCdnImageDetails(source.imageUrl as string, assetParams.default)
  };
}
